import { Category } from '@/entities/category';
import { apiClient } from '@/shared/api';

interface getCategoryPageDataProps {
  slug: string;
}

export async function getCategoryPageData(
  props: getCategoryPageDataProps,
): Promise<Category> {
  const { slug } = props;
  return await apiClient(`category/${slug}`);
}
